<template>
  <sf-dialog v-model="internalModel" scrollable :width="800">
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ $t('requestPrice') }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text class="d-flex flex-column">
        <sf-text class="mb-1">
          {{ $t('emailRequestPriceHint') }}
        </sf-text>
        <v-textarea
          v-model="previewSubject"
          :label="$t('collection.subject')"
          variant="outlined"
          hide-details
          readonly
          class="my-1"
          :rows="1"
          auto-grow
          density="compact"
          color="primary"
          autocomplete="off"
        />
        <sf-html-preview v-if="previewText" :preview-text="previewText" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <sf-text-button color="grey" class="text-medium-emphasis" @click="internalModel = false">
          {{ $t('cancel') }}
        </sf-text-button>
        <sf-text-button color="primary" :loading="sending" @click="sendRequest">
          {{ $t('send') }}
        </sf-text-button>
      </v-card-actions>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfHtmlPreview from '@/components/preview/SfHtmlPreview.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import SfText from '@/components/text/SfText.vue'
import SfDialog from '@/components/dialog/SfDialog.vue'
import useProductRequest from '@/modules/product/useProductRequest'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const props = defineProps({
  productId: {
    type: Number,
    required: true
  },
  supplierRowId: {
    type: Number,
    default: undefined
  }
})

const model = defineModel<boolean>({ default: false })
const internalModel = ref(false)

const { sending } = storeToRefs(useProductRequest())
const previewSubject = ref('')
const previewText = ref<string | undefined>(undefined)

watch(internalModel, (newValue) => {
  model.value = newValue
})

watch(model, async (newValue) => {
  if (newValue) {
    const data = await useProductRequest().getProductRequest(props.productId, props.supplierRowId)
    if (!data) {
      // unable to open dialog
      model.value = false
      return
    }
    previewSubject.value = data.subject || ''
    previewText.value = data.body || ''
  }
  // open dialog only after data has finished loading to prevent pop-ins
  internalModel.value = newValue
})

const sendRequest = async () => {
  await useProductRequest().sendProductRequest(props.productId)
  internalModel.value = false
}
</script>
